var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.342 5.245h2.75v-3.3h-2.75a3.855 3.855 0 0 0-3.85 3.85v1.65H7.29v3.3h2.2v8.802h3.3v-8.801h2.751l.55-3.3h-3.3V5.794c0-.298.252-.55.55-.55Z"
})));
export default SvgFacebook;